export default __webpack_public_path__ + "static/anticipamos-89759d8119b9166a3b0b89e870f4c3f5.png";